import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyVideoContainer = () => {
  return <PropertyDetail type="video" />;
};

export default PropertyVideoContainer;
